<section
  class="flex h-[calc(100dvh-200px)] items-center justify-center"
  data-testid="empty-view"
>
  <div class="flex w-full flex-col items-center gap-6">
    <!-- Icon -->
    <div class="w-24 h-24 rounded-full bg-primary-100 flex items-center justify-center">
      <app-greentripper-pin-icon styleClass="w-12 h-12 text-primary-500 ml-[7px]" />
    </div>

    <!-- Text -->
    <div class="flex flex-col items-center gap-2 text-center">
      <h1
        class="text-2xl font-semibold text-gray-800"
        data-testid="empty-view-title"
      >
        {{ "travelBoards.noTripsFound" | transloco }}
      </h1>
      <p class="text-gray-500 max-w-md" data-testid="empty-view-description">
        {{ "travelBoards.noTripsFoundExplanation" | transloco }}
      </p>
    </div>

    <!-- Button -->
    <p-button
      (click)="tripCreationModalService.createTrip()"
      icon="pi pi-plus"
      data-testid="empty-view-create-button"
      [pTooltip]="'travelBoards.addNewTrip' | transloco"
      label="{{ 'travelBoards.firstTrip' | transloco }}"
    />
    <app-trip-creation-modal />
  </div>
</section>
